import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IApplicationState } from '../../../../../types/redux/store';
import { Desktop } from '../../../../../../packages/Responsive';
import { disableRuler, enableRuler } from '../../../../../actions/ruler';
import { useMapContext } from '../../../context';
import { RulerButton } from './RulerButton';
import { trackRulerClick } from './tracking';

export const RulerButtonContainer: React.FC = props => {
  const dispatch = useDispatch();
  const { map } = useMapContext();
  const isRulerEnabled = useSelector((state: IApplicationState) => state.ruler.isEnabled);

  const handleClick = React.useCallback(() => {
    if (!isRulerEnabled) {
      dispatch(enableRuler());
    } else {
      dispatch(disableRuler());
    }

    trackRulerClick();
  }, [dispatch, isRulerEnabled]);

  return (
    <Desktop>
      <RulerButton {...props} map={map} isRulerEnabled={isRulerEnabled} onClick={handleClick} />
    </Desktop>
  );
};
